import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js";
import L from "leaflet"
import MarkerController from "./marker_controller";

// Connects to data-controller="monitoring--map--maps"
export default class extends MarkerController {
  static values = {
    markers: Array,
    center: Array
  }
  static targets = ["map"]


  connect() {
    this.initOSMap()
  }

  initOSMap() {
    this.map = L.map(this.mapTarget, {
      center: this.centerValue, zoom: 15
    })

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    this.loadMarkersOSM()
  }

  loadMarkersOSM() {
    this.markersValue.forEach(marker => {
      let markerHtml = `
            <i
                class="fa fa-map-marker fa-4x ${marker.color}">
            </i>
             `
      let bindPopup = marker.infowindow
      this.addMarker([parseFloat(marker.lat), parseFloat(marker.lng)], true, markerHtml, bindPopup);
    })
  }


}
